// extracted by mini-css-extract-plugin
export default {"popoverItem":"UserProfilePopover_popoverItem__Q+xbH","appVersion":"UserProfilePopover_appVersion__RE9qn"};